/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Use_Drop_OutInputs */



/**
* | output |
* | --- |
* | "Use DropOut for players who have played" |
*
* @param {Err_Tournament_Use_Drop_OutInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_use_drop_out = /** @type {((inputs?: Err_Tournament_Use_Drop_OutInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Use_Drop_OutInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utilisez Abandonner pour les joueurs ayant déjà joué")
	if (locale === "es") return /** @type {LocalizedString} */ ("Use Retirarse para jugadores que ya han jugado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Use Desistir para jogadores que já jogaram")
	if (locale === "it") return /** @type {LocalizedString} */ ("Usa Abbandona per i giocatori che hanno già giocato")
	return /** @type {LocalizedString} */ ("Use DropOut for players who have played")
});